<app-bookupp-header></app-bookupp-header>

<div class="jumbotron jumbotron-fluid">
    <div class="container-fluid flex-item mx-3 mx-md-5">
        <div class="row">
            <div class="col-12 col-md-4 p-5 d-flex align-items-center">
                <div>
                    <h1 class="hero-header text-light extra-large py-4">How it Works</h1>
                    <p class="text-white">Whether you’re a company or a parker - we’ll get your parking sorted in no time! Find out how it works below</p>
                    <br />
                    <div class="call-to-action">
                        <a class="btn btn-primary fw-bold" href="/bookupp-faqs#company-process">I'm a Company</a>&nbsp;&nbsp;&nbsp;&nbsp;
                        <a class="btn btn-other fw-bold" href="/bookupp-faqs#parker-process">I'm a Parker</a>
                    </div>
                    <br />
                </div>
            </div>
            <div class="col-md-6 d-none d-sm-block text-center d-flex align-items-center p-5">
                <!--                <img src="/assets/images/bookupp/phone.png"/>-->
            </div>
        </div>
    </div>
</div>

<div class="company-process py-md-5 bg-grey" id="company-process">
    <div class="container">
        <div class="row">
            <div class="col-12 py-5 text-center">
                <h1 class="">
                    <span class="header-part-light"> How to get </span>
                    <span class="fw-bold text-primary">started</span><br />
                </h1>
            </div>
        </div>
        <div class="row">
            <div class="col-12 col-lg-3 mt-0 mt-md-4 py-0 pt-5 py-md-5 px-4 text-center">
                <div class="block p-5">
                    <div class="step-card">
                        <div class="step-number">1</div>
                        <p><strong>Book a live demo</strong> in the contact form below.</p>
                    </div>
                </div>
            </div>

            <div class="col-12 col-lg-3 mt-0 mt-md-4 py-0 pt-5 py-md-5 px-4 text-center">
                <div class="block p-5">
                    <div class="step-card">
                        <div class="step-number">2</div>
                        <p><strong>We'll get in touch</strong> and run through the simple and easy to use platform and any questions you may have.</p>
                    </div>
                </div>
            </div>

            <div class="col-12 col-lg-3 mt-0 mt-md-4 py-0 pt-5 py-md-5 px-4 text-center">
                <div class="block p-5">
                    <div class="step-card">
                        <div class="step-number">3</div>
                        <p>Provide us with your <strong>corporate branding</strong> and <strong>parking floor plan.</strong></p>
                    </div>
                </div>
            </div>

            <div class="col-12 col-lg-3 mt-0 mt-md-4 py-0 pt-5 py-md-5 px-4 text-center">
                <div class="block p-5">
                    <div class="step-card">
                        <div class="step-number">4</div>
                        <p>We'll build and <strong>send you your dedicated ReserveUpp URL,</strong> landing page and live parking plan <strong>within 24 hours.</strong></p>
                    </div>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-12 col-lg-3 mt-0 mt-md-4 py-0 pt-5 py-md-5 px-4 text-center">
                <div class="block p-5">
                    <div class="step-card">
                        <div class="step-number">5</div>
                        <p>Click the link and register. Select your profile on the <strong>top right tab</strong> and choose <strong>Corporate Profile.</strong></p>
                    </div>
                </div>
            </div>

            <div class="col-12 col-lg-3 mt-0 mt-md-4 py-0 pt-5 py-md-5 px-4 text-center">
                <div class="block p-5">
                    <div class="step-card">
                        <div class="step-number">6</div>
                        <p>Select <strong>Authorised Parkers</strong> and enter your <strong>staff email addresses</strong> and invite them to ReserveUpp.</p>
                    </div>
                </div>
            </div>

            <div class="col-12 col-lg-3 mt-0 mt-md-4 py-0 pt-5 py-md-5 px-4 text-center">
                <div class="block p-5">
                    <div class="step-card">
                        <div class="step-number">7</div>
                        <p>Play with the intuitive options to <strong>customise your functionality</strong> and experience.</p>
                    </div>
                </div>
            </div>

            <div class="col-12 col-lg-3 mt-0 mt-md-4 py-0 pt-5 py-md-5 px-4 text-center">
                <div class="block p-5">
                    <div class="step-card">
                        <div class="step-number">8</div>
                        <p><strong>Your ReserveUpp is live.</strong> Book your bay, anytime from anywhere.</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="parker-process py-md-5 bg-grey" id="parker-process">
    <div class="">
        <div class="row">
            <div class="col-12 py-5 text-center">
                <h1 class=""><span class="fw-bold text-accent">Staff parking</span>&nbsp;<span class="header-part-light">process</span></h1>
            </div>
        </div>
        <div class="row">
            <div class="col-12 col-lg-1 mt-4 mt-lg-0 py-5 px-4 text-center d-none d-md-block"></div>

            <div class="col-12 col-lg-2 mt-md-4 py-0 pt-5 py-md-5 px-4 text-center">
                <div class="block py-5 px-2">
                    <div class="step-card">
                        <div class="step-number">1</div>
                        <p><strong>A ReserveUpp Parker invite is sent to you by email.</strong> Click to accept and register as prompted.</p>
                    </div>
                </div>
            </div>

            <div class="col-12 col-lg-2 mt-md-4 py-0 pt-5 py-md-5 px-4 text-center">
                <div class="block py-5 px-2">
                    <div class="step-card">
                        <div class="step-number">2</div>
                        <p>Once done, you will receive confirmation of your registration together with a <strong>link to your company's dedicated URL on WhatsApp.</strong></p>
                    </div>
                </div>
            </div>

            <div class="col-12 col-lg-2 mt-md-4 py-0 pt-5 py-md-5 px-4 text-center">
                <div class="block py-5 px-2">
                    <div class="step-card">
                        <div class="step-number">3</div>
                        <p>Click the link to the booking page, being sure to <strong>check that you are logged in.</strong></p>
                    </div>
                </div>
            </div>

            <div class="col-12 col-lg-2 mt-md-4 py-0 pt-5 py-md-5 px-4 text-center">
                <div class="block py-5 px-2">
                    <div class="step-card">
                        <div class="step-number">4</div>
                        <p><strong>Book a bay for any day</strong> up to a week in advance.</p>
                    </div>
                </div>
            </div>

            <div class="col-12 col-lg-2 mt-md-4 py-0 pt-5 py-md-5 px-4 text-center">
                <div class="block py-5 px-2">
                    <div class="step-card">
                        <div class="step-number">5</div>
                        <p><strong>Check your WhatsApp</strong> for your booking receipt.</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="pricing-overview py-md-5 bg-dark-blue">
    <div class="container">
        <div class="row">
            <div class="text-center mb-5">
                <h1 class="mb-4"><span class="header-part-light">How much does it</span>&nbsp;<strong>cost?</strong></h1>
                <p>No Capex and no contract. Just a simple parking solution for your business at an affordable rate.</p>
            </div>

            <div class="row justify-content-center">
                <div class="col-md-6 col-lg-4 mb-3 text-center px-5">
                    <i class="fa fa-check round-check mb-3"></i>
                    <h4 class="card-title mb-4">To set up your profile</h4>
                    <p class="">A once-off fee of R1500 is required to build your corporate ReserveUpp landing page, URL and design your live parking plan.</p>
                </div>

                <div class="col-md-6 col-lg-4 mb-3 text-center px-5 border-left">
                    <i class="fa fa-check round-check mb-3"></i>
                    <h4 class="card-title mb-4">The monthly fee</h4>
                    <p class="">It only costs R10 per parker per month, payable on the 25th of the preceding month. All amounts quoted exclude VAT at 15%.</p>
                </div>
            </div>
        </div>
    </div>
</div>

<section class="contact-form bg-dark-blue">
    <a class="anchor-offset" id="contact-form-anchor"></a>
    <div class="container aos-init aos-animate" data-aos="fade-up">
        <div class="row">
            <div class="col-12 col-md-6 py-5 my-5">
                <h1 class="">
                    <span class="">We’re ready when you are</span>
                </h1>
                <p class="my-4">Let us run you through the functionalities of the platform, share our expertise and set up your ReserveUpp profile. <strong>All in 20 minutes.</strong></p>

                <ng-container *ngIf="formComplete">
                    <div class="alert alert-success" role="alert">We have received your enquiry. We will contact you soon.</div>
                    <a [routerLink]="'/bookupp'" class="text-decoration-underline">Click here to send another enquiry</a>
                </ng-container>
                <ng-container *ngIf="!formComplete">
                    <form (ngSubmit)="onSubmit()" [formGroup]="formGroup">
                        <input class="form-control d-none" formControlName="type" type="text" />

                        <div class="row">
                            <div class="col-12 col-md-6 mb-3">
                                <label class="form-label">Name</label>
                                <input class="form-control" formControlName="name" type="text" />
                            </div>

                            <div class="col-12 col-md-6 mb-3">
                                <label class="form-label">Email Address</label>
                                <input class="form-control" formControlName="email" type="email" />
                            </div>

                            <div class="col-12 col-md-6 mb-3">
                                <label class="form-label">Phone</label>
                                <input class="form-control" formControlName="phone" type="text" />
                            </div>

                            <div class="col-12 col-md-6 mb-3">
                                <label class="form-label">Company</label>
                                <input class="form-control" formControlName="company" type="text" />
                            </div>
                        </div>

                        <div class="mb-3">
                            <label class="form-label">Building Address</label>
                            <input class="form-control" formControlName="location" type="text" />
                        </div>

                        <ng-container *ngIf="formError">
                            <div class="alert alert-danger pa-3" role="alert">
                                <pre>{{ formError }}</pre>
                            </div>
                        </ng-container>

                        <ng-container [ngTemplateOutlet]="formLoading ? formInvalidTemplate : validTemplate"></ng-container>
                        <ng-template #formSubmittingTemplate>
                            <button class="btn btn-dark" disabled type="submit">
                                <span aria-hidden="true" class="spinner-border spinner-border-sm" role="status"></span>
                                Loading...
                            </button>
                        </ng-template>
                        <ng-template #formInvalidTemplate>
                            <button class="btn btn-dark" disabled type="submit">Submit</button>
                        </ng-template>
                        <ng-template #validTemplate>
                            <button class="btn btn-dark" type="submit">Submit</button>
                        </ng-template>
                    </form>
                </ng-container>
            </div>
        </div>
    </div>
</section>

<app-bookupp-footer></app-bookupp-footer>
